const baseUrl = '/settings/staffs';

class StaffsService {
    constructor() {}

    async fetchStaffs(offset = '') {
        let result = await ApiClient.get(baseUrl, { limit: 100, offset });
        const staffs = result.data.data;
        while (staffs.length < result.data.pagination.total) {
            result = await ApiClient.get(baseUrl, {
                limit: 100,
                offset: result.data.pagination.offset,
            });
            staffs.push(...result.data.data);
        }
        return staffs;
    }
}

export const staffsService = new StaffsService();
